import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

class TermsAndConditions extends Component {
	render() {
		const { franchisor } = this.props;
		const termsAndCоnditionsHtml = franchisor && franchisor.termsAndConditions;

		return (<div>
			{termsAndCоnditionsHtml && <div dangerouslySetInnerHTML={{ __html: termsAndCоnditionsHtml }} />}
		</div>);
	}
}

const mapStateToProps = state => ({
	franchisor: state.configuration.franchisor
});

export default connect(mapStateToProps)(withTranslation()(TermsAndConditions));